var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5644_216878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.29 17.79L18 16.5V11.5C18 8.43 16.36 5.86 13.5 5.18V4.5C13.5 3.67 12.83 3 12 3C11.17 3 10.5 3.67 10.5 4.5V5.18C7.62999 5.86 5.99999 8.42 5.99999 11.5V16.5L4.70999 17.79C4.07999 18.42 4.51999 19.5 5.40999 19.5H18.58C19.48 19.5 19.92 18.42 19.29 17.79ZM16 17.5H7.99999V11.5C7.99999 9.02 9.50999 7 12 7C14.49 7 16 9.02 16 11.5V17.5ZM12 22.5C13.1 22.5 14 21.6 14 20.5H9.99999C9.99999 21.6 10.89 22.5 12 22.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5644_216878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.dc0bd01c021abd7261304fb4e9d21d7d.svg";
export { ForwardRef as ReactComponent };